import { render, staticRenderFns } from "./LoginAttemptsModal.vue?vue&type=template&id=6ebf8b4a&scoped=true&"
import script from "./LoginAttemptsModal.vue?vue&type=script&lang=js&"
export * from "./LoginAttemptsModal.vue?vue&type=script&lang=js&"
import style0 from "./LoginAttemptsModal.vue?vue&type=style&index=0&id=6ebf8b4a&lang=scss&scoped=true&"
import style1 from "./LoginAttemptsModal.vue?vue&type=style&index=1&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebf8b4a",
  null
  
)

export default component.exports